import { useGetApiWorkspacesByIdPermissionsQuery } from '@/model/workspace/api.generated';
import type { Permission } from '@/model/workspace/permission.generated';
import { useAppSelector } from '@/shared/hooks/useStore';
import { selectCurrentWorkspace } from '@/viewmodel/features/workspace/state/workspacesSlice';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useCallback } from 'react';

export interface WorkspacePermissionsViewModel {
  can: (permission: Permission) => boolean;
  isLoading: boolean;
}

export function useWorkspacePermissionsViewModel(): WorkspacePermissionsViewModel {
  const workspaceId = useAppSelector(selectCurrentWorkspace)?.id;
  const { currentData, isLoading } = useGetApiWorkspacesByIdPermissionsQuery(
    workspaceId ? { id: workspaceId } : skipToken,
  );
  const can = useCallback(
    (permission: Permission): boolean => currentData?.permissions?.includes(permission) ?? false,
    [currentData],
  );

  return { can, isLoading: !workspaceId || isLoading };
}
